<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="add-supplier">
        <el-form
          ref="form"
          :model="supplierForm"
          label-position="left"
          label-width="100px"
          size="mini"
        >
          <div class="supplier-title">机构类型</div>
          <el-radio-group
            v-model="type"
            size="small"
            style="padding-left: 10px;"
          >
            <el-radio border label="1">联盟商家</el-radio>
            <el-radio border label="2">供货商</el-radio>
            <el-radio border label="3">运营中心</el-radio>
          </el-radio-group>
          <div class="supplier-title">供货商信息</div>
          <el-form-item label="供货商名称">
            <el-input v-model="supplierForm.name"></el-input>
          </el-form-item>
          <el-form-item label="供货品类">
            <el-select multiple v-model="supplierForm.categoryIds">
              <el-option
                v-for="item in categoryOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="supplierForm.contact"></el-input>
          </el-form-item>
          <el-form-item label="供货商电话">
            <el-input v-model="supplierForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="supplierForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="登录密码">
            <el-input v-model="supplierForm.password"></el-input>
          </el-form-item>
          <!-- <el-form-item label="登录密码">
            <el-input
              :value="supplierForm.password"
              @input="newPassword = $event"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="供货商地址">
            <el-input
              v-model="supplierForm.address"
              style="width: 460px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照">
            <el-upload
              action=""
              class="upload-demo"
              :http-request="uploadSectionFile"
              :limit="1"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item size="large">
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button @click="onDismiss">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  uploadFile1,
  getCategorys,
  getSupplierDetail,
  addSupplier,
  updateSupplier
} from "api/request";
import { ERR_OK } from "api/config";
import { formatDate, loadingInstance, Success, Error } from "common/js/util";
export default {
  components: { MSidebar, MHeader },
  data() {
    return {
      // newPassword: "", // 新增属性用于存储新密码
      categoryOptions: [],
      type: "2",
      fileList: [],
      categoryId: null,
      supplierId: null,
      supplierForm: {}
    };
  },
  mounted() {
    console.log("mounted: 组件已挂载");
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    console.log("从localStorage获取的getUserInfo:", getUserInfo);
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this.fileyHeader = {
        token: getUserInfo.token,
        "Content-Type": "multipart/form-data"
      };
      this._getCategory();
      this.supplierId = window.localStorage.getItem("supplierId");
      console.log("从localStorage获取的supplierId:", this.supplierId);
      if (this.supplierId != null) {
        this._getSupplierDetail();
        window.localStorage.removeItem("supplierId");
      }
    }
  },
  methods: {
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 102);
      uploadFile1(form).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.supplierForm.businessLicense = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getCategory() {
      let param = {};
      loadingInstance(Loading);
      getCategorys(param).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.categoryOptions = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    _getSupplierDetail() {
      console.log("_getSupplierDetail: 开始获取供应商详细信息");
      let param = {
        supplierId: parseInt(this.supplierId)
      };
      console.log("请求参数:", param);
      loadingInstance(Loading);
      getSupplierDetail(param).then(res => {
        console.log("获取的供应商详细信息:", res);
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.supplierForm = res.data;
          console.log("更新后的supplierForm:", this.supplierForm);
          if (this.supplierForm.cfAdminVos != null) {
            // this.supplierForm.userName = this.supplierForm.cfAdminVos[0].userName;
            // this.supplierForm.password = this.supplierForm.cfAdminVos[0].password; //师父我把这句话删除就好了，但是我不知道原因
            this.$set(
              this.supplierForm,
              "userName",
              this.supplierForm.cfAdminVos[0].userName
            );
            this.$set(
              this.supplierForm,
              "password",
              this.supplierForm.cfAdminVos[0].password
            );
          }
          if (this.supplierForm.businessLicense != null) {
            this.fileList.push({
              name: this.supplierForm.businessLicense,
              url: this.supplierForm.businessLicense
            });
          }
        } else {
          Error(this, res);
        }
      });
    },
    onDismiss() {
      this.$router.push({
        path: "/supplier"
      });
    },
    onSubmit() {
      loadingInstance(Loading);
      if (this.supplierForm.id) {
        updateSupplier(this.supplierForm).then(res => {
          loadingInstance(Loading).close();
          if (res.status === ERR_OK) {
            Success(this, res);
            this.$router.push({
              path: "/supplier"
            });
          } else {
            Error(this, res);
          }
        });
      } else {
        addSupplier(this.supplierForm).then(res => {
          loadingInstance(Loading).close();
          if (res.status === ERR_OK) {
            Success(this, res);
            this.$router.push({
              path: "/supplier"
            });
          } else {
            Error(this, res);
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.add-supplier {
  height: fit-content;
  margin: 30px;
  box-sizing: border-box;
}
.supplier-title {
  width: 100%;
  display: inline-block;
  float: left;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333333;
}
.el-form-item {
  margin-left: 10px;
}
</style>
<style>
.add-supplier .el-input {
  width: 300px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}
.add-supplier .el-button {
  width: 100px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier/addSupplier.vue